<template>

  <div class="d-flex flex-column fill-height overflow-y-auto" style="position:absolute;width:100%;height:100%;">
    <v-virtual-scroll :items="filteredJobs" item-height="84" bench="10" class="mt-4">
      <template #default="{item}">
        <JobBlock :job="item" :enableDrop="false" />
      </template>
    </v-virtual-scroll>
    </div>
    
</template>

<style lang="scss" scoped>
.selected{
  background-color: lightblue;
}
</style>

<script>
import { mapGetters,  mapActions } from 'vuex';
import JobBlock from './JobBlock.vue';
//import LoadingBlock from './LoadingBlock.vue';
//import Sortable from 'sortablejs'

export default {
  name: 'AutoPriorities',
  components: {
    JobBlock
  },
  props: {
    stage: { type: String, default: null, required: false },
    filter: { type: String, default: null, required: false },
    jobs: { type: Array, required: true },
    queue: { type: Array, required: true },
  },
  data(){ return {
    loading: false,
    virtualItemHeight: 28,
    sortable: null,
    selected: null,
    contextMenu: {
      item: null,
      x: null,
      y: null,
    }
  }},
  computed:{
    ...mapGetters("AUTH", ["USER"]),

    filteredJobs(){
      let jobs = this.queue.map(xid => this.jobs.find(j => j.xid == xid));
      jobs = jobs.filter(j => this.stage == null || j.stage.xid == this.stage);
      if(this.filter){
        let terms = this.filter.toLowerCase().split(' ').filter(f => f,length);
        jobs = jobs.filter(j => terms.every(term =>
          j.number.replaceAll('-', '').toLowerCase().includes(term.replaceAll('-', ''))
          || j.customer?.name.toLowerCase().includes(term)
          || j.customer_acc.toLowerCase().includes(term)
        ));
      }
      return jobs;
    },

  },
  watch: {
  },

  methods: {
    ...mapActions("UI", ["SET_TITLE", "CONFIRM", "NAVIGATE"]),
    ...mapActions("API", ["API"]),

    clickJob(e, job){
      if(e.ctrlKey)
        this.openNewTab(job);
      else
        this.selected = this.selected == job.xid ? null : job.xid;
    },

    rightClickJob(e, job){
      this.contextMenu = { ...this.contextMenu,
        item: job,
        x: e.clientX, y: e.clientY
      };
      e.preventDefault();
    },

  },
  mounted(){
  }
}
</script>
